import React from "react";

const Hero = () => {
  return (
    <div className="mt-[100px] p-8">
      <h1 className="text-aquamarine text-[18px] ">Hi, I am</h1>
      <h1 className="text-white text-[34px] ">Toni Odujinrin</h1>
      <h2 className="text-olive text-[34px]">I am a software developer </h2>
    </div>
  );
};

export default Hero;
